interface AudioLevelMeterProps {
  level: number;
}

/**
 * Displays live microphone input level.
 */
export function AudioLevelMeter({ level }: AudioLevelMeterProps) {
  const percent = Math.min(Math.max(level * 100, 0), 100);

  return (
    <div className="space-y-2">
      <div className="flex items-center justify-between text-sm text-ink-200">
        <span>Microphone level</span>
        <span>{Math.round(percent)}%</span>
      </div>
      <div className="h-2 rounded-full bg-white/10 overflow-hidden">
        <div
          className="h-full bg-gradient-to-r from-primary-400 via-accent-cyan to-accent-amber transition-all"
          style={{ width: `${percent}%` }}
        />
      </div>
    </div>
  );
}
